import Coordinate from "./Coordinate";

export default class PolyCoordinate extends Coordinate {
    constructor(provider, absX, absY, parent, index) {
        super(provider, absX, absY);
        this.parent = parent;
        this.index = index;
    }

    calculateRatio() {
        this.xRatio = (this.absX - this.parent.absMinX) / this.parent.absWidth;
        this.yRatio = (this.absY - this.parent.absMinY) / this.parent.absHeight;
    }

    drag(dx, dy) {
        this.move(dx, dy, true);
    }

    move(dx, dy, withUpdate = true) {
        if (dx == 0 && dy == 0) {
            return;
        }
        super.move(dx, dy);
        if (withUpdate) {
            this.parent.updateSupportCoordinates();
            this.calculateRatio();
            this.updateInputs();
            this.parent.row.updateImg();
        }
    }

    updateInputs() {
        if (!this.prevInput && !this.nextInput) {
            this.initInputs();
        }
        if (this.prevInput) {
            this.prevInput.value(this.distanceTo(this.prevCoordinate));
        }
        if (this.nextInput) {
            this.nextInput.value(this.distanceTo(this.nextCoordinate));
        }
    }

    initInputs() {
        let multiInput = this.getTab('info').input.multiInput;
        if (this.parent.isPolygon() || this.index > 0) {
            this.prevCoordinate = this.parent.coordinates.at((this.index - 1 + this.parent.length) % this.parent.length);
            this.prevInput = multiInput.getInput((this.parent.length + (this.index - 1)) % this.parent.length);
        }
        if (this.parent.isPolygon() || this.index < this.parent.length) {
            this.nextCoordinate = this.parent.coordinates.at((this.index + 1) % this.parent.length);
            this.nextInput = multiInput.getInput(this.index);
        }
    }

    resetInputs() {
        this.prevInput = undefined;
        this.nextInput = undefined;
    }
}
